<template>
  <component
    :is="iconComponent"
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent, h } from 'vue'

const icons = {
  Office: () =>
    h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '20',
        height: '20',
        viewBox: '0 0 20 20',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '1',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
      [
        h('path', { d: 'M3 17h15v-8h-4v-4h-11v12z' }),
        h('path', { d: 'M14 9v4' }),
        h('circle', { cx: '7', cy: '17', r: '2' }),
        h('circle', { cx: '16', cy: '17', r: '2' }),
      ],
    ),

  MapPin: () =>
    h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
      [
        h('path', { d: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' }),
        h('circle', { cx: '12', cy: '10', r: '3' }),
      ],
    ),

  Clock: () =>
    h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
      [
        h('circle', { cx: '12', cy: '12', r: '10' }),
        h('polyline', { points: '12 6 12 12 16 14' }),
      ],
    ),

  Calendar: () =>
    h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
      [
        h('rect', { x: '3', y: '4', width: '18', height: '18', rx: '2', ry: '2' }),
        h('line', { x1: '16', y1: '2', x2: '16', y2: '6' }),
        h('line', { x1: '8', y1: '2', x2: '8', y2: '6' }),
        h('line', { x1: '3', y1: '10', x2: '21', y2: '10' }),
      ],
    ),

  ArrowRight: () =>
    h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
      [
        h('line', { x1: '5', y1: '12', x2: '19', y2: '12' }),
        h('polyline', { points: '12 5 19 12 12 19' }),
      ],
    ),

  HelpCircle: () =>
    h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
      [
        h('circle', { cx: '12', cy: '12', r: '10' }),
        h('path', { d: 'M9 9a3 3 0 0 1 6 0c0 2-3 3-3 3v2' }),
        h('circle', { cx: '12', cy: '17', r: '0.5' }),
      ],
    ),

  Annotation: () =>
    h(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: '24',
        height: '24',
        viewBox: '0 0 24 24',
      },
      [
        h('circle', {
          cx: '12',
          cy: '12',
          r: '11',
          fill: 'none',
          stroke: '#FF0000',
          strokeWidth: '2.5',
        }),
        h('line', {
          x1: '12',
          y1: '5',
          x2: '12',
          y2: '14',
          stroke: '#FF0000',
          strokeWidth: '2.5',
          strokeLinecap: 'round',
        }),
        h('circle', {
          cx: '12',
          cy: '18',
          r: '1.5',
          fill: '#FF0000',
        }),
      ],
    ),

  Yen: () =>
    h(
      'span',
      {
        style: {
          display: 'inline-block',
          fontSize: 'inherit',
          lineHeight: '1',
        },
      },
      '￥',
    ),
}

export default defineComponent({
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
      validator: (value: string) => Object.keys(icons).includes(value),
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name as keyof typeof icons]
    },
  },
})
</script>
